export const verificationsConfig = {
  // Cooldown period in seconds before allowing resend
  resendCooldown: 60,

  // OTP expiration time in minutes
  otpExpiration: 10,

  // OTP length
  otpLength: 8,
}
